import React, { useEffect, useState, useRef, useCallback } from "react";
import AkkhorLayout from "../layout/akkhor";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import Axios from "axios";
import { URL_LIST_ALL } from "../configs/api";
import { useSelector } from "react-redux";
import Loading from "../component/Loading";

export default function BaiHocChiTiet() {
    const { id } = useParams();
    const { user } = useSelector((state) => state.auth);
    const [detail, setDetail] = useState(null)
    const [loading, setLoading] = useState(false)
    const [pageNumber, setPageNumber] = useState(1)
    const [totalPage, setTotalPage] = useState(1)
    const [currentPage, setCurrentPage] = useState(null)
    const [listPage, setListPage] = useState([])

    useEffect(() => {
        if (id > 0) {
            setLoading(true);
            Axios.get(URL_LIST_ALL + "learninghub_baigiang/" + id, user.config)
                .then((res) => {
                    setLoading(false);
                    if (res.data.status === "success") {
                        const data = res.data.data;
                        setDetail(data);
                        setTotalPage(data.totalpage);
                        setListPage(data.list_baigiang || []);

                        // 🟢 Dùng vị trí mà user đang theo dõi
                        const initialPageNumber = data.user_view_current_page || 1;

                        // Tìm trang tương ứng
                        const found = data.list_baigiang.find(
                            (p) => p.position === initialPageNumber
                        );

                        setPageNumber(initialPageNumber);
                        if (found) setCurrentPage(found);
                    } else {
                        console.log(res.data.message);
                    }
                })
                .catch((err) => console.log(err));
        }
    }, [user, id]);


    useEffect(() => {
        console.log(pageNumber);

        if (listPage.length > 0) {
            const found = listPage.find((p) => p.position === pageNumber);
            if (found) setCurrentPage(found);
            // Gửi API cập nhật tiến trình học
            Axios.post(URL_LIST_ALL + "learninghub_user_pages", {
                user_id: user.data.id,
                baigiang_id: id,
                page_number: pageNumber,
            }, user.config).catch(err => console.log(err));
        }
    }, [pageNumber, listPage]);

    const linkify = (html) =>
        html.replace(
            /(?<!src="|href="|">)(https?:\/\/[^\s<]+)/g,
            '<a href="$1" class="text-danger" target="_blank" rel="noopener noreferrer">$1</a>'
        );

    return (
        <AkkhorLayout idrole="dashboard">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/khoa-hoc">Khóa học</Link>
                    </li>
                    <li>
                        <Link to={"/khoa-hoc-chi-tiet/" + (detail && detail.type_id)}>{detail && detail.tenkhoahoc}</Link>
                    </li>
                    <li>
                        {detail && detail.title}
                    </li>
                </ul>
            </div>
            <div className="card height-auto mt-2">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>{currentPage && currentPage.title}</h3>
                        </div>
                    </div>
                    <div className="w-100 body-page">
                        {loading && <Loading />}
                        {currentPage && <div className="w-100 mt-2 post-content" dangerouslySetInnerHTML={{ __html: linkify(currentPage.page_content) }} />}
                    </div>
                    <div className="w-100 d-flex justify-content-between mt-5 mb-5">
                        <button type="button" className="btn btn-sm btn-outline-info" disabled={pageNumber <= 1} onClick={() => setPageNumber(pageNumber - 1)}>Trang trước</button>
                        <button type="button" className="btn btn-sm btn-outline-info" disabled={pageNumber >= totalPage} onClick={() => setPageNumber(pageNumber + 1)}>Trang sau</button>
                    </div>
                </div>
            </div>

        </AkkhorLayout>
    )
}